import { render, staticRenderFns } from "./UldkToolsSettings.vue?vue&type=template&id=116e5d32&"
import script from "./UldkToolsSettings.vue?vue&type=script&lang=js&"
export * from "./UldkToolsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports